var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center",
                  attrs: { xl: "9", lg: "9", md: "7", sm: "7", cols: "7" }
                },
                [
                  _c(
                    "v-avatar",
                    {
                      staticClass: "ma-3 tech-icon",
                      attrs: { size: "100", tile: "" }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src: "/static/uploads/" + _vm.digitalOffer.image
                        },
                        on: { error: _vm.setAltImg }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("h2", [_vm._v(_vm._s(_vm.digitalOffer.name))])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center justify-end",
                  attrs: { xl: "3", lg: "3", md: "5", sm: "5", cols: "5" }
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-fab",
                      on: {
                        click: function($event) {
                          return _vm.goBack()
                        }
                      }
                    },
                    [_c("md-icon", [_vm._v("arrow_back")])],
                    1
                  ),
                  _vm._v(" "),
                  _vm.loggedIn
                    ? _c(
                        "md-button",
                        {
                          staticClass: "md-fab md-primary",
                          on: {
                            click: function($event) {
                              _vm.showDialog = true
                            }
                          }
                        },
                        [
                          _c("md-icon", [_vm._v("bookmarks")]),
                          _vm._v(" "),
                          _c(
                            "md-tooltip",
                            { attrs: { "md-direction": "left" } },
                            [
                              _vm._v(
                                _vm._s(_vm.digitalOffer.name) +
                                  " zum Unternehmensprofil\n            hinzufügen"
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { xl: "7", lg: "7", md: "7", sm: "6", cols: "12" } },
                [
                  _c("p", {
                    staticClass: "tech-describtion",
                    domProps: {
                      innerHTML: _vm._s(_vm.digitalOffer.description)
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { staticClass: "d-flex justify-flex-start flex-wrap" },
                    [
                      _c("div", { staticClass: "tagWrapper" }, [
                        _c("h4", { staticClass: "pl-3" }, [
                          _vm._v("Zielbranche")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "v-chip",
                              {
                                staticClass: "ma-2 white--text",
                                attrs: { color: "#9a2a28" }
                              },
                              [_vm._v(_vm._s(_vm.digitalOffer.targetSector))]
                            )
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tagWrapper" }, [
                        _c("h4", { staticClass: "pl-3" }, [
                          _vm._v("Themenfelder")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.digitalOffer.topicOne
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 white--text",
                                    attrs: { color: "#9a2a28" }
                                  },
                                  [_vm._v(_vm._s(_vm.digitalOffer.topicOne))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.digitalOffer.topicTne
                              ? _c(
                                  "v-chip",
                                  {
                                    staticClass: "ma-2 white--text",
                                    attrs: { color: "#9a2a28" }
                                  },
                                  [_vm._v(_vm._s(_vm.digitalOffer.topicTwo))]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "d-flex justify-end pl-5",
                  attrs: { xl: "5", lg: "5", md: "5", sm: "6", cols: "12" }
                },
                [
                  _c(
                    "v-card",
                    { attrs: { raised: "true" } },
                    [
                      _c(
                        "v-list",
                        [
                          _c("v-subheader", { staticClass: "black--text" }, [
                            _c("h3", [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.digitalOffer.competenceCenter.name
                                  ) + " "
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("v-list-item", [
                            _c("img", {
                              staticClass: "cc_logo",
                              attrs: {
                                src:
                                  "/static/uploads/" +
                                  _vm.digitalOffer.competenceCenter.logo
                              },
                              on: { error: _vm.setAltImg }
                            })
                          ]),
                          _vm._v(" "),
                          _c("v-subheader", { staticClass: "black--text" }, [
                            _c("h3", [_c("b", [_vm._v("Kontakt ")])])
                          ]),
                          _vm._v(" "),
                          _c("v-list-item", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "mailto:" + _vm.digitalOffer.contact
                                }
                              },
                              [_vm._v(_vm._s(_vm.digitalOffer.contact))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("v-subheader", { staticClass: "black--text" }, [
                            _c("h3", [_c("b", [_vm._v("Link ")])])
                          ]),
                          _vm._v(" "),
                          _c("v-list-item", [
                            _c(
                              "a",
                              { attrs: { href: _vm.digitalOffer.link } },
                              [_vm._v("Zum Angebot")]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6eddda7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6eddda7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/offersearch/detail/OfferDetail.vue
// module id = null
// module chunks = 